import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const processDataService = {
  getData: async (user, processDataId) => {
    return await axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/${processDataId}`,
      getAxiosOptions(user)
    )
  },
  getInterProcessData: (user, pivotFieldTemplateId, processId, listDataId) => {
    return axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/get-inter-process-import-data/${pivotFieldTemplateId}/${listDataId}/${processId}`,
      getAxiosOptions(user)
    )
  },
  saveProcessData: (user, processDataId, processDataValue, modifiedByID) => {
    /* delete updated key from allValue data */
    const values = processDataValue
    delete values['updatedAt']

    // finally, save to database
    if (values && Object.keys(values).length > 0) {
      const body = { data: values }
      if (modifiedByID != null) body.modifiedBy = modifiedByID

      axios.put(
        `${NODE_BASE_URL}/data-entry/process-data/${processDataId}`,
        body,
        getAxiosOptions(user)
      )
    }
  },
  updateProcessData: async (user, processDataId, processDataValue, modifiedByID) => {
    /* delete updated key from allValue data */
    const values = processDataValue
    delete values['updatedAt']

    // finally, save to database
    if (values && Object.keys(values).length > 0) {
      const body = { data: values }
      if (modifiedByID != null) body.modifiedBy = modifiedByID

      await axios.patch(
        `${NODE_BASE_URL}/data-entry/process-data/${processDataId}`,
        body,
        getAxiosOptions(user)
      )
    }
  },
  initiateNewProcess: async (user, processTemplateId) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/data-entry/process-data`,
        { process_template_id: processTemplateId },
        getAxiosOptions(user)
      )
    ).data
  },
  saveProcessReviewData: (user, processDataId, processReviewData, modifiedByID) => {
    /* delete updated key from allValue data */
    const values = processReviewData
    delete values['updatedAt']

    axios.put(
      `${NODE_BASE_URL}/data-entry/process-data/review-data/${processDataId}`,
      {
        reviewData: values,
        modifiedBy: modifiedByID,
        lrpReviewDetails: [{ review_by: user.id, review_at: Date.now() }],
      },
      getAxiosOptions(user)
    )
  },
  saveProcessCommentData: (user, processDataId, processCommentData, modifiedByID) => {
    /* delete updated key from allValue data */
    const values = processCommentData
    delete values['updatedAt']

    axios.put(
      `${NODE_BASE_URL}/data-entry/process-data/review-comments-data/${processDataId}`,
      {
        reviewCommentData: values,
        modifiedBy: modifiedByID,
      },
      getAxiosOptions(user)
    )
  },
  saveProcessSelectableTableData: (user, processId, selectedRows, modifiedById) => {
    axios.put(
      `${NODE_BASE_URL}/data-entry/process-data/selectable-table-data/${processId}`,
      {
        selectableTableData: selectedRows,
        modifiedBy: modifiedById,
      },
      getAxiosOptions(user)
    )
  },

  outboundServerActions: (user, activityTemplateId, routeTemplateId) => {
    return axios.get(
      `${NODE_BASE_URL}/template/server-actions/outbound/${activityTemplateId}/${routeTemplateId}`,

      getAxiosOptions(user)
    )
  },

  updateOutboundServerActions: (user, outbound_server_action_status, id) => {
    return axios.put(
      `${NODE_BASE_URL}/template/server-actions`,
      {
        outbound_server_action_status,
        id,
      },
      getAxiosOptions(user)
    )
  },

  createNextProcess: (user, processId, selectedToRoute, other = {}) => {
    return axios.post(
      `${NODE_BASE_URL}/data-entry/process-data/next`,
      {
        current_process_data_id: processId,
        next_route_template_id: selectedToRoute,
        ...other,
      },
      getAxiosOptions(user)
    )
  },
  getPreviousProcessData: async (user, processId) => {
    return await axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/get-previous-process-data-values/${processId}`,
      getAxiosOptions(user)
    )
  },
  checkProcessCreationStatus: async (user, processTemplateId, activityTemplateId, processId) => {
    return await axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/prevent-process-creation/${processTemplateId}/${activityTemplateId}/${processId}`,
      getAxiosOptions(user)
    )
  },
  getPivotFieldFilterData: (user, pivotFieldTemplateId) => {
    return axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/pivot-field-filter-data/${pivotFieldTemplateId}/${user.id}`,
      getAxiosOptions(user)
    )
  },
  getProcessDataByProcessTemplateId: (user, processTemplateId) => {
    return axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/process/${processTemplateId}`,
      getAxiosOptions(user)
    )
  },
  getProcessDataExcludingRejectedByProcessTemplateId: (user, processId, query = {}) => {
    const queryString =
      Object.keys(query).length > 0 ? `?${new URLSearchParams(query).toString()}` : ''

    return axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/process-excluding-rejected/${processId}${queryString}`,
      getAxiosOptions(user)
    )
  },
  getSumAcrossProcessComputation: (user, processId, query = {}) => {
    const queryString =
      Object.keys(query).length > 0 ? `?${new URLSearchParams(query).toString()}` : ''

    return axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/sum-across-process-computation/${processId}${queryString}`,
      getAxiosOptions(user)
    )
  },
  backFillingDataInRecurringTable: async (user, processId) => {
    return await axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/${processId}`,
      getAxiosOptions(user)
    )
  },
  getAllPreviousReviews: async (user, fieldId, processId) => {
    return await axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/get-all-previous-review-values/${fieldId}/${processId}`,
      getAxiosOptions(user)
    )
  },
  saveOverallComments: async (user, processId, overallComments) => {
    return axios.put(
      `${NODE_BASE_URL}/data-entry/process-data/overall-comments/${processId}`,
      {
        overallComments,
        modifiedBy: user.id,
      },
      getAxiosOptions(user)
    )
  },
  delegateTask: async (user, data) => {
    return await axios.post(`${NODE_BASE_URL}/data-entry/delegation`, data, getAxiosOptions(user))
  },
  getBadgeData: async (user) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/data-entry/process-data/get-badge-count`,
        getAxiosOptions(user)
      )
    ).data
  },
  tableSubfieldValidationAcrossProcess: async (user, constraintId, processId) => {
    return await axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/table-field-validation-across-process/${constraintId}/${processId}`,
      getAxiosOptions(user)
    )
  },
}
